import { RoundPhase } from "../constants/RoundPhase";

export const convertStatusToRoundPhase = (roundStatus: number) => {
  if (roundStatus === 0)
  {
    return RoundPhase.initialPhase;
  }
  if (roundStatus === 1)
  {
    return RoundPhase.openRedCard;
  }
  if (roundStatus === 2)
  {
    return RoundPhase.playBlackCard;
  }
  if (roundStatus === 3)
  {
    return RoundPhase.waitForOthersToPlay;
  }
  if (roundStatus === 4)
  {
    return RoundPhase.lookAtPlayedCards;
  }
  if (roundStatus === 5)
  {
    return RoundPhase.roundWinner;
  }
  return RoundPhase.initialPhase;
}

export const convertRoundPhaseToStatus = (roundPhase: RoundPhase) => {
  if (roundPhase === RoundPhase.initialPhase)
  {
    return 0;
  }
  if (roundPhase === RoundPhase.openRedCard)
  {
    return 1;
  }
  if (roundPhase === RoundPhase.playBlackCard)
  {
    return 2;
  }
  if (roundPhase === RoundPhase.waitForOthersToPlay)
  {
    return 3;
  }
  if (roundPhase === RoundPhase.lookAtPlayedCards)
  {
    return 4;
  }
  if (roundPhase === RoundPhase.roundWinner)
  {
    return 5;
  }
  return 0;
}